module.exports = __webpack_public_path__ + "img/ic-evacuacionazul.8fb8de59.png";